export default "__VITE_ASSET__080b9a23__"